import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  DialogActions,
} from "@material-ui/core";

function MembersChartComponent(props) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [members, setMembers] = useState([]);
  const [memberchartOptions, setmemberChartOptions] = useState({
    series: [
      {
        data: [20, 2, 45, 10],
      },
    ],
    options: {
      chart: {
        background: "#fff",
        toolbar: {
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
          },
        },
        type: "area",
        height: 250,
        zoom: false,
        pan: false,
      },
      xaxis: {
        categories: [],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      title: {
        text: `Total No. of Members`,
        align: "right",
        offsetX: -20,
        offsetY: 60,
        floating: false,
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#263238",
        },
      },
      subtitle: {
        text: `${members.length}`,
        align: "right",
        offsetX: -20,
        offsetY: 20,
        floating: false,
        style: {
          fontSize: "24px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#000",
        },
      },
      yaxis: {
        show: false,
        label: {
          show: false,
        },
      },
      stroke: {
        width: 1,
        curve: "smooth",
        colors: ["#9f35f1"],
      },
      tooltip: {
        enabled: false,
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: false,
      },
      markers: {
        size: 0,
        style: "hollow",
        colors: ["#9f35f1"],
        strokeColor: "#fff",
        strokeWidth: 1,
      },
      fill: {
        colors: ["#E4d1ee"],
      },
    },
  });

  useEffect(() => {
    const getmembers = axios.get(`api/admin/client/team`);

    Promise.all([getmembers]).then((responses) => {
      const membersData = responses[0].data;

      let num = Object.keys(membersData ).map((key) => membersData [key]);
      let member = num[0].map((user) => user);
      setMembers(member);

      setmemberChartOptions({
        series: [
          {
            data: [20, member.length, 60],
          },
        ],
        options: {
          subtitle: {
            text: `${member.length}`,
            align: "right",
            offsetX: -20,
            offsetY: 20,
            floating: false,
            style: {
              fontSize: "24px",
              fontWeight: "bold",
              fontFamily: undefined,
              color: "#000",
            },
          },
        },
      });
    });
  }, []);
  const handleOpenMember = () => {
    setDialogOpen(true);
  };

  const handleCloseMember = () => {
    setDialogOpen(false);
  };
  return (
    <div>
      <div className="chart" onClick={handleOpenMember}>
        <ReactApexChart
          options={memberchartOptions.options}
          series={memberchartOptions.series}
          type="area"
        />
      </div>
      <Dialog
        open={dialogOpen}
        onClose={handleCloseMember}
        maxWidth="md"
        PaperProps={{
          style: { width: 520, height: 690, boxShadow: "none" },
        }}
      >
        <DialogTitle>Members Information</DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                  Name
                </TableCell>
                <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                  EMAIL
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members &&
                members
                  .sort((a, b) => a.lastname.localeCompare(b.lastname)) // sort by lastname alphabetically
                  .map((user, index) => {
                    // console.log("MEMEBERSS", user);
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {user.firstname} {user.lastname}
                        </TableCell>
                        <TableCell>{user.email}</TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMember} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MembersChartComponent;
